export const VAT_NUMBER_LENGTH = 11;
